<template>
    <section class="content">
        <div class="container-fluid">
            <div class="card">
                <div class="fn-header">
                    การจัดการเกมแพคเกจ
                </div>


                <div class="row search-section">
                    <div class="col-sm-2 col-search">

                        <button type="button" class="btn bg-teal waves-effect btn-search" @click="add()">
                            <i class="material-icons">add_box</i>
                            <span>สร้างเกมแพคเกจ</span>
                        </button>

                    </div>
                    <div class="col-sm-3 col-search"></div>
                    <div class="col-sm-2 col-search">
                        <input type="text" class="search-textbox" v-model="key"
                            placeholder="กรุณากรอกชื่อแพคเกจ เพื่อค้นหา" style="width:100%;margin-top:5px">
                    </div>

                    <div class="col-sm-2 col-search">
                            <select v-model="search_game_id" class="form-control  show-tick">
                                    <option :value="0">เลือกเกม</option>
                                    <option v-for="(value,index) in games" :key="'game-key-' + index" :value="value.id" v-html="value.game_name"></option>
                                </select>
                    </div>

                    <div class="col-sm-2 col-search">
                        <button type="button" class="btn bg-blue-grey  waves-effect btn-search" :disabled="searching"
                            @click="search(1)">
                            <i class="material-icons">search</i>
                            <span>ค้นหา</span>
                        </button>
                    </div>
                    <div class="col-sm-1 col-search">
                        <button type="button" class="btn bg-grey waves-effect btn-search" :disabled="searching"
                            @click="reset()">
                            <i class="material-icons">refresh</i>
                            <span>Reset</span>
                        </button>
                    </div>

                </div>
               
                <div class="body table-responsive" style="width:100%">
                     <div  style="width: 100%;margin: 0 auto;">
                        <div class="diamon-text" @click="addDiamond()">
                            
                            <i class="material-icons" style="font-size: 30px;color: #42a442;vertical-align: middle;">add_circle</i>
                             <span style="font-size: 14px;color: #42a442;">เพิ่มรูปภาพ</span>
                        </div>
                        <div  style="border: 1px solid #ccc;min-height: 50px;margin-bottom: 15px;">
                            <div style="margin-top: 20px;">
                                <div v-for="(values,index) in diamonds" :key="'diamond-' + index" style="position: relative;display: flex;justify-content: flex-start;align-items: center;">
                                    <div v-for="(item, i) in values" :key="'diamond-item-' + i" style="width:105px;height: 100px;display: flex;flex-direction: column;align-items: center;margin-right: 15px;position: relative;" v-if="item.id > 1">
                                        <div>
                                        <i class="material-icons diamond-edit-icon" @click="editDiamond(item.id)">mode_edit</i>
                                        <i class="material-icons diamond-del-icon" @click="delDiamond(item.id)">cancel</i>
                                        </div>
                                        <div>
                                        <img :src="item.image" :alt="item.name"  style="width: 70px;">
                                        </div>
                                   
                                    <div>{{ item.name }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                
                    <div class="preloader pl-size-xl" v-if="searching == true || loading == true">
                        <div class="spinner-layer pl-orange">
                            <div class="circle-clipper left">
                                <div class="circle"></div>
                            </div>
                            <div class="circle-clipper right">
                                <div class="circle"></div>
                            </div>
                        </div>
                    </div>
                    <div v-else>


                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th class="fn-th" style="width: 80px;">No.</th>
                                    <th class="fn-th">รูปภาพ</th>
                                    <th class="fn-th">เกม</th>
                                    <th class="fn-th">ชื่อแพ็คเกจ</th>
                                    <th class="fn-th">ราคา Wepay</th>
                                    <th class="fn-th">ราคา Wepay2</th>
                                    <th class="fn-th">ราคา Wepay3</th>
                                    <th class="fn-th">ราคา Wepay4</th>
                                     <th class="fn-th">ราคา</th>
                                    <th class="fn-th">กำไร</th>
                                    <th class="fn-th">สถานะ</th>
                                    <th class="fn-th">แก้ไข</th>
                                    <th class="fn-th">ลบ</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in items" :key="'p-' + item.id"
                                    :class="{ 'fn-tr-light': index % 2, 'fn-tr-dark': !(index % 2) }">
                                    <td v-html="((page-1) * perpage) + index + 1"></td>
                                    <td style="text-align: center;">
                                        <span>{{ item.diamond_name }}</span>
                                    </td>

                                    <td style="text-align: center;">
                                        <span>{{ item.game_name }}</span>
                                    </td>

                                    <td style="text-align: center;">
                                        <span>{{ item.package_name }}</span>
                                    </td>
                                   
                                     <td style="text-align: center;">
                                        <span>{{ item.wepay_price }}</span>
                                    </td>
                                     <td style="text-align: center;">
                                        <span>{{ item.wepay_price2 }}</span>
                                    </td>
                                     <td style="text-align: center;">
                                        <span>{{ item.wepay_price3 }}</span>
                                    </td>
                                     <td style="text-align: center;">
                                        <span>{{ item.wepay_price4 }}</span>
                                    </td>
                                     <td style="text-align: center;">
                                        <span>{{ item.price }}</span>
                                    </td>
                                    <td style="text-align: center;">
                                        <span>{{ item.profit }}</span>
                                    </td>
                                    <td style="text-align: center;">
                                        <span>{{ item.active == 1 ? 'Active' : 'Inactive' }}</span>
                                    </td>
                                   

                                    <td>
                                        <span @click="edit(item.id)">
                                            <a href="#">
                                                <i class="material-icons fn-icon">mode_edit</i>
                                            </a>
                                        </span>
                                    </td>
                                    <td>
                                        <span @click="del(item.id)">
                                            <a href="#">
                                                <i class="material-icons fn-icon" style="color:red;">cancel</i>
                                            </a>
                                        </span>
                                    </td>

                                </tr>
                            </tbody>

                        </table>
                    </div>

                    <Paginate v-model=page :page-count=pages :page-range="5" :click-handler="search" :prev-text="'Prev'"
                        :next-text="'Next'" :container-class="'fn-pagination'" />


                </div>
            </div>
        </div>
        <div class="modal fade" id="game-modal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header" style="padding:10px">

                        <span style="color: #466aa7;font-size: 15px;font-weight: bold;">สร้างเกมแพ็คเกจ</span>
                    </div>
                </div>
                <div class="modal-body" style="background:white;min-height: 0;">

                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2  col-label">
                            <span>เกม</span>
                        </div>
                        <div class="col-sm-10">
                           
                            <select v-model="game_id" class="form-control  show-tick fn-required" :disabled="package.id > 0" @change="getPackage(game_id)">
                                <option :value="0">เลือกเกม</option>
                                 <option v-for="(value,index) in games" :key="'game-key-' + index" :value="value.id" v-html="value.game_name"></option>
                            </select>
                        </div>
                    </div>
                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2  col-label">
                            <span>ชื่อแพ็คเกจ</span>
                        </div>
                        <div class="col-sm-10">
                           
                            <input type="text" class="form-control fn-required" v-model="package.package_name" placeholder="กรุณากรอกชื่อแพ็คเกจ">
                        </div>
                    </div>
                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2  col-label">
                            <span>เลือกรูปภาพ</span>
                        </div>
                        <div class="col-sm-10">
                           
                            <select v-model="package.diamond_id" class="form-control  show-tick fn-required">
                                 <option v-for="(value,index) in diamond_images" :key="'game-key-' + index" :value="value.id" v-html="value.name"></option>
                            </select>
                        </div>
                    </div>
                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2 col-label">
                            <span>ราคา(Wepay)</span>
                        </div>
                        <div class="col-sm-6">
                             <select v-model="package.wepay_price" class="form-control  show-tick fn-required">
                                
                                 <option v-for="(value,index) in prices" :key="'company-key-' + index" :value="value" v-html="value"></option>
                            </select>
                        </div>
                        <div class="col-sm-4" style="text-align: left;padding-top: 5px;">
                            <span style="color: red;font-size: 12px;">*ราคาที่มาจาก Wepay</span>
                        </div>
                    </div>
                   <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2 col-label">
                            <span>ราคา(Wepay)2</span>
                        </div>
                        <div class="col-sm-6">
                             <select v-model="package.wepay_price2" class="form-control  show-tick fn-required">
                                <option :value="0">0</option>
                                 <option v-for="(value,index) in prices" :key="'company-key-' + index" :value="value" v-html="value"></option>
                            </select>
                        </div>
                        <div class="col-sm-4" style="text-align: left;padding-top: 5px;">
                            <span style="color: red;font-size: 12px;">*ราคาที่มาจาก Wepay 2</span>
                        </div>
                    </div>
                   <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2 col-label">
                            <span>ราคา(Wepay)3</span>
                        </div>
                        <div class="col-sm-6">
                             <select v-model="package.wepay_price3" class="form-control  show-tick fn-required">
                                <option :value="0">0</option>
                                 <option v-for="(value,index) in prices" :key="'company-key-' + index" :value="value" v-html="value"></option>
                            </select>
                        </div>
                        <div class="col-sm-4" style="text-align: left;padding-top: 5px;">
                            <span style="color: red;font-size: 12px;">*ราคาที่มาจาก Wepay 3</span>
                        </div>
                    </div>
                     <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2 col-label">
                            <span>ราคา(Wepay)4</span>
                        </div>
                        <div class="col-sm-6">
                             <select v-model="package.wepay_price4" class="form-control  show-tick fn-required">
                                <option :value="0">0</option>
                                 <option v-for="(value,index) in prices" :key="'company-key-' + index" :value="value" v-html="value"></option>
                            </select>
                        </div>
                        <div class="col-sm-4" style="text-align: left;padding-top: 5px;">
                            <span style="color: red;font-size: 12px;">*ราคาที่มาจาก Wepay 4</span>
                        </div>
                    </div>

                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2 col-label">
                            <span>ราคา</span>
                        </div>
                        <div class="col-sm-6">
                            <input type="number" class="form-control fn-required" v-model="package.price">
                        </div>
                    </div>
                  
                     <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2 col-label">
                            <span>กำไร</span>
                        </div>
                        <div class="col-sm-6">
                            <input type="number" class="form-control fn-required" v-model="package.profit" placeholder="กรุณากรอกกำไร">
                        </div>
                    </div>
                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2 col-label">
                            <span>สถานะ</span>
                        </div>
                        <div class="col-sm-6">
                            <select class="form-control  show-tick fn-required" v-model="package.active">
                                <option value="1">Active</option>
                                <option value="0">Inactive</option>
                            </select>
                        </div>
                    </div>

                </div>
                <div class="modal-footer" style="background:white">
                  
                    <button type="button" class="btn btn-primary waves-effect" style="width: 150px;"
                        @click="handleSave()"  :disabled="saving">
                        
                        บันทึก
                    </button>
                    <button type="button" class="btn btn-default waves-effect" style="width: 150px;"
                        data-dismiss="modal">ปิด</button>
                </div>
            </div>
        </div>

         <div class="modal fade" id="diamond-modal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header" style="padding:10px">

                        <span style="color: #466aa7;font-size: 15px;font-weight: bold;">สร้างรูปภาพแพ็คเกจ</span>
                    </div>
                </div>
                <div class="modal-body" style="background:white;min-height: 0;">

                    <div class="row" style="margin-top:20px">
                        <div class=" col-sm-2"></div>
                        <div class="col-sm-10" style="text-align: center;">
                            
                             <div style="margin-top: 15px;" v-if="diamond.image">
                                <img :src="diamond.image" class="img-box" alt="i-game"/>
                                <div style="margin-top: 10px;">
                                <i class="material-icons del-image-icon" @click="deleteImage()">clear</i>
                                </div>
                             </div>
                             <div v-else>
                                <button class="file-upload-btn" type="button" @click="uploadClick()">+เพิ่มรูปภาพ</button>
                                 <input class="file-upload-input" type='file' ref="uploadFile"
                                @change="handleFilesUpload(this);" accept="image/*" />
                            </div>
                        </div>

                    </div>
                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2  col-label">
                            <span>ชื่อรูปภาพ</span>
                        </div>
                        <div class="col-sm-10">
                           
                            <input type="text" class="form-control fn-required" v-model="diamond.name" placeholder="กรุณากรอกชื่อรูปภาพ">
                        </div>
                    </div>
                     
                </div>
                <div class="modal-footer" style="background:white">
                    <button type="button" class="btn btn-primary waves-effect" style="width: 150px;height: 35px;"
                        @click="handleSaveDiamond()" :disabled="saving">บันทึก</button>
                    <button type="button" class="btn btn-default waves-effect" style="width: 150px;height: 35px;"
                        data-dismiss="modal">ปิด</button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import GameService from '../../service/GameService'
import WepayService from '../../service/WepayService'
import GamePackageService from '../../service/GamePackageService'
import helper from '../../classes/helper'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment'
import alertBox from '../../classes/alertBox'
import Paginate from 'vuejs-paginate'

export default {
    name: "GamePackageManage",
    components: {
        DatePicker,
        Paginate
    },
    data() {
        return {
            user: JSON.parse(localStorage.getItem('user')),
            page: 1,
            perpage: 50,
            total: 0,
            pages: 0,
            items: [],
            games: [],
            gameData: [],
            prices: [],
            package: {},
            diamonds: [],
            diamond_images: [],
            diamond: {},
            game_id: 0,
            saving: false,
            file: null,
            search_game_id: 0,
            key: "",
            searching: false,
            loading: false,
        }
    },
    async created() {
        Promise.all([
            this.getGames(),
            this.getDiamonds(),
            this.getData(),
            this.search(1)
        ])
    },
    mounted() {

    },
    methods: {
         async getGames() {
            let response = await GameService.get()

            if(response.status){
                this.games = response.result.sort((a, b) => a.game_name.localeCompare(b.game_name))
            }
        },
        async getDiamonds() {
            let response = await GamePackageService.getDiamonds()
            console.log(response)
            if(response.status){
                this.diamond_images = response.result.sort((a, b) => a.id - b.id)
                this.diamonds = this.chunkArray(this.diamond_images, 12)
                
            }
        },
         async getData  () {
            let response = await WepayService.get('gtopup')
           
            if(response.status){
                this.gameData = response.result
            }
        },
         getPackage(game_id){
            let game = this.games.find(x => x.id == game_id)
            let company = this.gameData.find(x => x.company_id == game.company_id)
            if(company){
               
                 this.prices = company.denomination.map(x => x.price).sort((a, b) => a - b)
            }
           
        },
        //onPriceChange(){
           //this.package.price = this.package.wepay_price * this.package.times
        //},
        async search(p = 0) {
             if (p > 0) {
                this.page = p
            }
            this.loading = true
            
            let response = await GamePackageService.search(this.key, this.search_game_id, this.page, this.perpage)
          
            if (response.status) {
                let { page, perpage, total, pages, data } = response.result
                this.page = Number(page)
                this.perpage = Number(perpage)
                this.total = Number(total)
                this.pages = Number(pages)
                this.items = data

            }
            this.loading = false
        },
        reset(p = 1) {
            this.key = ""
            this.search_game_id = 0
            this.search(p)
        },
        add() {
            this.package = {
                id: 0,
                game_id: 0,
                package_name: "",
                diamond_id: 1,
                price: 0,
                wepay_price: 0,
                wepay_price2: 0,
                wepay_price3: 0,
                wepay_price4: 0,
                times: 1,
                profit: 0,
                active: "1",
                created_by: this.user.id
            }
            $('#game-modal').modal('show')
        },
        edit(id) {
            this.getPackage(this.items.find(x => x.id == id).game_id)
            let item = this.items.find(x => x.id == id)
            
            this.package = { 
                ...item,
                price: item.price ? Number.parseFloat(item.price) : 0,
                wepay_price: item.wepay_price ? Number.parseFloat(item.wepay_price) : 0,
                wepay_price2: item.wepay_price2 ? Number.parseFloat(item.wepay_price2) : 0,
                wepay_price3: item.wepay_price3 ? Number.parseFloat(item.wepay_price3) : 0,
                wepay_price4: item.wepay_price4 ? Number.parseFloat(item.wepay_price4) : 0,
                profit: item.profit ? Number.parseFloat(item.profit) : 0,
                times: item.times ? Number.parseInt(item.times) : 1,
                diamond_id: item.diamond_id ? Number.parseInt(item.diamond_id) : 1,
                updated_by: this.user.id 
            }
            this.game_id = item.game_id
           
            $('#game-modal').modal('show')
        },
        async handleSave() {
            if (!this.validate()) {
                return false
            }

            if (this.package.id == 0) {
                await this.create()
            }
            else {
                await this.update()
            }

            $('#game-modal').modal('hide')
        },
        validate() {
            if (!this.package.package_name) {
                alertBox.error("กรุณากรอกชื่อแพ็กเกจ")
                return false
            }

            if(this.package.wepay_price <= 0){
                alertBox.error("กรุณาเลือกราคา Wepay")
                return false
            }

             if(this.package.times <= 0){
                alertBox.error("กรุณากรอกจำนวนครั้ง")
                return false
            }

             if(this.package.profit < 0){
                alertBox.error("กำไรต้องมากกว่าหรือเท่ากับ 0")
                return false
            }
            

            return true
        },
        async create() {
            try {
                this.saving = true
                this.package.game_id = this.game_id
              
                let response = await GamePackageService.create(this.package)
               
                if (response.status) {
                    alertBox.success('save success')
                    this.saving = false
                    this.reset(this.page)
                }
                else {
                    alertBox.error("Error, " + response.error)
                }
                this.saving = false
            }
            catch (error) {
                alertBox.error("Error, " + error)
                this.saving = false
            }
        },
        async update() {
            try {
                this.saving = true
                this.package.game_id = this.game_id
                let response = await GamePackageService.update(this.package)
               
                if (response.status) {
                    alertBox.success('save success')
                    this.saving = false
                    this.reset(this.page)
                }
                else {
                    alertBox.error("Error, " + response.error)
                }
                this.saving = false
            }
            catch (error) {
                alertBox.error("Error, " + error)
                this.saving = false
            }
        },
        async del(id) {
            let result = await alertBox.confirm('คุณแน่ใจที่จะลบ?')
            if (result) {
                let data = {
                    id: id,
                    updated_by: this.user.id
                }
                let response = await GamePackageService.delete(data)

                if (response.status) {
                    this.reset(this.page)
                }
                else {
                    alertBox.error("Error, " + response.error)
                }
            }
        },
         uploadClick(){
            this.$refs.uploadFile.click()
        },
        handleFilesUpload() {
             let uploadedFiles = this.$refs.uploadFile.files;
            this.diamond.image = URL.createObjectURL(uploadedFiles[0])
            this.file = uploadedFiles[0]
            this.$refs.uploadFile.value = ""
        },
        addDiamond() {
            this.diamond = {
                id: 0,
                image: "",
                name: "",
            }
            $('#diamond-modal').modal('show')
        },
        editDiamond(id) {
            console.log(id)
            let diamond = this.diamond_images.find(x => x.id == id)
            console.log(diamond)
            this.diamond = {
                ...diamond
            }
            $('#diamond-modal').modal('show')
        },
        async handleSaveDiamond() {
            if (this.diamond.id == 0) {
                await this.createDiamond()
            }
            else {
                await this.updateDiamond()
            }
        },
        async createDiamond() {
            if (!this.diamond.name) {
                alertBox.error("กรุณากรอกชื่อรูปภาพ")
                return false
            }
            if (!this.file) {
                alertBox.error("กรุณาเลือกรูปภาพ")
                return false
            }
            try {
                this.saving = true
                let formData = new FormData();
                formData.append('name', this.diamond.name );
                formData.delete('file');
                if (this.file) {
                    formData.append('file', this.file);
                }

                let response = await GamePackageService.createDiamond(formData)
               
                if (response.status) {
                    alertBox.success('save success')
                    this.saving = false
                    this.getDiamonds()
                     $('#diamond-modal').modal('hide')
                }
                else {
                    this.saving = false
                    alertBox.error("Error, " + response.error)
                }
            }
            catch (error) {
                this.saving = false
                alertBox.error("Error, " + error)
            }
        },
         async updateDiamond() {
            console.log(this.diamond)
            if (!this.diamond.name) {
                alertBox.error("กรุณากรอกชื่อรูปภาพ")
                return false
            }
            if (!this.diamond.image) {
                alertBox.error("กรุณาเลือกรูปภาพ")
                return false
            }
            try {
                this.saving = true
                let formData = new FormData();
                formData.append('id', this.diamond.id);
                formData.append('name', this.diamond.name );
                formData.append('image', this.diamond.image );
                formData.delete('file');
                if (this.file) {
                    formData.append('file', this.file);
                }

                let response = await GamePackageService.updateDiamond(formData)
               
                if (response.status) {
                    alertBox.success('save success')
                    this.saving = false
                    this.getDiamonds()
                    this.reset(this.page)
                     $('#diamond-modal').modal('hide')
                }
                else {
                    this.saving = false
                    alertBox.error("Error, " + response.error)
                }
            }
            catch (error) {
                this.saving = false
                alertBox.error("Error, " + error)
            }
        },
        async delDiamond(id) {
            let result = await alertBox.confirm('คุณแน่ใจที่จะลบ?')
            if (result) {
                let data = {
                    id: id
                }
                this.saving = true
                let response = await GamePackageService.deleteDiamond(data)

                if (response.status) {
                    this.getDiamonds()
                }
                else {
                    alertBox.error("Error, " + response.error)
                }
            }
        },
        async deleteImage() {
            const result = await alertBox.confirm('คุณแน่ใจที่จะลบ?')
            
            if (result) {
                this.diamond.image = ""
            }

        },
         chunkArray(array, size) {
            const chunkedArr = [];
            for (let i = 0; i < array.length; i += size) {
                let newArray = array.slice(i, i + size);
                let maxHeight = Math.max(...newArray)
                newArray = newArray.map(item => ({ ...item, height: maxHeight }))
                chunkedArr.push(newArray);
            }
            return chunkedArr;
        },
    },
    filters: {
        comma(value) {
            return helper.WithComma(value)
        },
        date(value) {
            if (!value) return ""

            return moment(value).format('DD/MM/YYYY HH:mm')
        }
    }
}
</script>

<style scoped>
.diamon-text {
    position: absolute;
    width: 140px;
    cursor: pointer;
    text-align: left;
    margin-top: -15px;
    margin-left: 2px;
    background: white;
    z-index: 10;
    padding: 2px 5px;
    border-radius: 5px;
}

.clear-img{
        cursor: pointer;
        color:red;
        font-size:16px;
        vertical-align: middle;
    }
    .img-box{
        cursor: zoom-in;
        max-height : 160px;
    }
    
    .file-upload {
        background-color: #ffffff;
        width: 600px;
        margin: 0 auto;
        padding: 20px;
    }

    .file-upload-btn {
        width: 100%;
        color: #2196f3;
        background: #fff;
        border: 1px dashed #2196f3;
        padding: 10px;
        border-radius: 4px;
        /* border-bottom: 4px solid #15824B; */
        transition: all .2s ease;
        outline: none;
        text-transform: uppercase;
        font-weight: 700;
    }

    .file-upload-btn:hover {
        background: #2196f3;
        color: #ffffff;
        transition: all .2s ease;
        cursor: pointer;
    }

    .file-upload-btn:active {
        border: 0;
        transition: all .2s ease;
    }

    .file-upload {
        background-color: #ffffff;
        width: 600px;
        margin: 0 auto;
        padding: 20px;
    }

    .file-upload-content {
        display: none;
        text-align: center;
    }

    .file-upload-input {
        position: absolute;
        margin: 0;
        padding: 0;
        width: 100%;
        height: 100%;
        outline: none;
        opacity: 0;
        cursor: pointer;
    }   

    .image-title-wrap {
        padding: 0 15px 15px 15px;
        color: #222;
    }

    .file-upload-image {
        max-height: 200px;
        max-width: 200px;
        margin: auto;
        padding: 20px;
    }
    .del-image-icon{
        color: red;
        cursor: pointer;
        font-size: 21px;
    }
    .diamond-edit-icon{
        position: absolute;
        top: 0;
        right: -5px;
        font-size: 17px;
        border: 1px solid;
        cursor: pointer;
    }

     .diamond-del-icon{
        position: absolute;
        top: 25px;
        right: -5px;
        color: red;
        font-size: 18px;
        cursor: pointer;
    }
   
</style>


// WEBPACK FOOTER //
// src/components/Manage/GamePackage.vue